import { useEffect } from 'react';
import EnergiaSolar from '../components/templates/EnergiaSolar';
import { useSimuladorEnergiaSolarState } from '../modules/simulador-energia-solar';

export default function EnergiaSolarPage() {
  const { clearStateStorage } = useSimuladorEnergiaSolarState();

  useEffect(() => {
    clearStateStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <EnergiaSolar />;
}

export async function getStaticProps() {
  return {
    props: {
      energiaSolar: true,
    },
  };
}
